/** Capitalize each word of a sentence. */
export function capitalize (sentence: string | undefined, separator = ' ') {
    if (!sentence) {
        return '';
    }

    const splitSentence = sentence.split(separator).map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return splitSentence.join(' ');
}